
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.749 22.335l11.628-11.628a.999.999 0 10-1.414-1.414L22.335 20.921 10.707 9.293a.999.999 0 10-1.414 1.414l11.628 11.628L9.293 33.963a.999.999 0 101.414 1.414L22.335 23.75l11.628 11.628a.997.997 0 001.414 0 .999.999 0 000-1.414L23.749 22.335z"}})])
          )
        }
      }
    